import { useParams } from 'react-router'

interface CreditRouteParams {
    estate: string;
    credit: string;
}

export default function useCreditParams() {
    const { estate, credit } = useParams<CreditRouteParams>()

    return {
        estate,
        creditId: credit ? parseInt(credit, 10) : undefined,
    }
}
